// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing183({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/178/1.gif`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      qTitleColor="#0166ff"
      qOptionColor="blue"
      formFieldColor="white"
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      eventDates={true}
      apiUrl={apiUrl}
    />
  );
}

export default Randing183;
